import {navigation} from "./partials/navigation";
import {accordion} from "./blocks/accordion";
import {loadmore} from './partials/loadmore';
import {animateOnScroll} from "./partials/animate-on-scroll";
import {quotes} from './partials/quote.js';
import {filterMembers} from './partials/filter-team-members.js';
import {companiesFilters} from './partials/company-filters.js';
import {postRollFilters} from './partials/post-roll-filters.js';
import {companydropdown} from './blocks/companies-accordion.js';
import {hidedropdown} from './blocks/companies-accordion.js';
import {featured_talks} from './blocks/featured-talks';
import {heroOverhangListener} from './partials/hero-with-overhang';
import {menuBG} from "./partials/menu-bg-color";
import InitCredoHeroSectionFunctionality from "./blocks/credo-hero-section";
import InitContentAreaWithTOC from "./blocks/content-area-with-toc/ContentAreaWithTOC";
import {bodyClassCheck} from "./pages/body-class-check";
import {podcast_carousel} from "./blocks/podcastcarousel";

$(function () {
    navigation();
    InitCredoHeroSectionFunctionality();
    InitContentAreaWithTOC();
    accordion();
    loadmore();
    animateOnScroll();
    quotes();
    filterMembers();
    companydropdown();
    companiesFilters();
    postRollFilters();
    hidedropdown();
    menuBG();
    heroOverhangListener();
    featured_talks();
    bodyClassCheck();
});